import classNames from 'classnames'
import { Icon, type IIconsVector, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import styles from './styles.module.scss'

type IAddNumberCardProps = {
  icon: IIconsVector
  title: string
  subtitle: string
  path?: string
  customId?: string
  handleClick?: () => void
  isDisabled?: boolean
  isSelected?: boolean
}

export const AddNumberCard = ({
  customId,
  icon,
  title,
  path,
  subtitle,
  handleClick,
  isDisabled,
  isSelected,
}: IAddNumberCardProps) => {
  return (
    <div
      id={customId}
      className={classNames(styles.cardContainer, {
        [styles.isDisabled]: isDisabled,
        [styles.isSelected]: isSelected,
      })}
      onClick={() => {
        if (isDisabled) return
        handleClick?.()
        path &&
          uiStore.changeRouteViaVue({
            path,
          })
      }}
    >
      <div className={styles.iconContainer}>
        <Icon
          icon={icon}
          fontSize={16}
          color={
            isDisabled
              ? 'var(--content-neutral-primary)'
              : isSelected
              ? 'var(--content-brand-secondary)'
              : 'var(--content-primary-tertiary)'
          }
        />
      </div>
      <div className={styles.info}>
        <Typography variant='body-md-regular' ariaLabel='BuyNumberTitle'>
          {title}
        </Typography>
        <Typography
          variant='body-sm-regular'
          color={isDisabled ? 'var(--content-primary-disabled)' : 'tertiary'}
          ariaLabel='BuyNumberSubtitle'
          className={styles.subtitle}
        >
          {subtitle}
        </Typography>
      </div>
    </div>
  )
}
